import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { StateUtils } from '@spartacus/core';
import { TrackingDelivery } from '@tracking/const';
import { TrackingDeliveryService } from '@tracking/feature';
import { Observable } from 'rxjs';

@Component({
  selector: 'sd-tracking-delivery',
  templateUrl: './tracking-delivery.component.html',
  styleUrls: ['./tracking-delivery.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TrackingDeliveryComponent implements OnInit {
  trackingState$: Observable<StateUtils.LoaderState<TrackingDelivery>>;

  constructor(private trackingDeliveryService: TrackingDeliveryService) {}

  ngOnInit(): void {
    this.trackingDeliveryService.loadByQueryParams();
    this.trackingState$ = this.trackingDeliveryService.getTrackingStateByQueryParams();
  }
}
